/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.finance.controllers', [])

.controller('FinanceController', ['$scope', function($scope) {

    $scope.finance = {

      model: "Your spankin new application.finance view!",

      init: function() {},

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      }

    };

    $scope.finance.init();

}]);